import { EmailsThemeDto } from "@babackapp/private-api-client/types";


const defaultEmailsTheme: Required<EmailsThemeDto> =  {
  radius: 'default',
  disableShadow: true, // Deprecated, not working with emails
  backgroundColor: '#fcfcfc',
  cardColor: '#ffffff',
  backgroundTextColor: '#000000',
  cardTextColor: '#000000',
  primaryColor: '#2563eb',
  primaryTextColor: '#ffffff',
  secondaryColor: '#f43f5e',
  secondaryTextColor: '#ffffff',
  fontFamily: null,
  fontUrl: null,
}

export default defaultEmailsTheme;
